import { render } from "./FourCards.vue?vue&type=template&id=4949eefa&scoped=true"
import script from "./FourCards.vue?vue&type=script&lang=js"
export * from "./FourCards.vue?vue&type=script&lang=js"

import "./FourCards.vue?vue&type=style&index=0&id=4949eefa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4949eefa"]])

export default __exports__